import ApplicationElement from '../application_element/element.js';
import CommonActions from '../common_actions/element.js';

export class BaseMenu extends ApplicationElement {
  static properties = {
    open: { type: Boolean, reflect: true },
  };

  static registerCommonActions(tagName) {
    window.commonActions ||= {};
    window.commonActions[tagName] = this;
  }

  constructor() {
    super();
    this.commonActions = new CommonActions(this);

    this.addEventListener('dropdown-opened', () => {
      this.open = true;
    });

    this.addEventListener('dropdown-closed', () => {
      this.open = false;
    });
  }

  connectedCallback() {
    super.connectedCallback();

    this.constructor.index ||= {};
    this.constructor.index[this.instanceId] = this;
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    delete this.constructor.index[this.instanceId];
  }

  /** @internal */
  get instanceId() {
    throw new Error('Implement instance ID on parent class');
  }

  /** @internal */
  get dotMenuElement() {
    return this.shadowRoot.querySelector('ef-dot-menu');
  }

  openMenu() {
    this.dotMenuElement.open();
  }
}

export default BaseMenu;
